import React from "react";
import moment from "moment";

const BirthDate = ({ data, summary: isSummary, extensions: extensions }) => {
  if (isSummary) {
    const sourceCode = extensions
      ? extensions.filter(e => e.url.includes("birthSrcCode"))
      : "";
    return (
      <div>
        Date Of Birth: {data && moment(data).format("L")}{" "}
        {sourceCode[0] ? "[" + sourceCode[0].valueString + "]" : ""}
      </div>
    );
  }
  return (
    <div>
      <h4>Date Of Birth</h4>
      <div>{data && moment(data).format("L")}</div>
    </div>
  );
};

export default BirthDate;
